import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import PopUp from './PopUp'

const PopUpError = ({
  text,
  visible,
  textButton,
  functionButton,
  intl,
}) => {
  const { formatMessage } = intl

  let message = formatMessage({
    id: 'application.error.notConnected',
    defaultMessage: 'Not connected to Altrac server. Please connect to internet and reload app.',
    description: '',
  })
  switch (text) {
    case 'Login failed':
      message = formatMessage({
        id: 'application.error.loginInvalid',
        defaultMessage: 'Invalid username or password entered. Please try again.',
        description: '',
      })
      break
    case 'Login Server Request Failed':
      message = formatMessage({
        id: 'application.error.loginServer',
        defaultMessage: 'Login server request failed. Please log out and try again.',
        description: '',
      })
      break
    case 'Server Error':
      // eslint-disable-next-line no-case-declarations
      const messageBody = formatMessage({
        id: 'application.error.server',
        defaultMessage: 'Altrac server error. Please log out and try again. Contact Altrac support if this continues to happen: ',
        description: '',
      })
      // eslint-disable-next-line no-case-declarations
      const phone = formatMessage({
        id: 'support.phone.value',
        defaultMessage: '+1 510 248 4141',
        description: '',
      })
      // eslint-disable-next-line no-case-declarations
      const email = formatMessage({
        id: 'support.email.value',
        defaultMessage: 'support@altrac.io',
        description: '',
      })
      message = (
        <div>
          {messageBody}
          <br />
          {phone}
          <br />
          <a href={`mailto:${email}`}>{email}</a>
        </div>
      )
      break
    case 'Unauthorized':
      message = formatMessage({
        id: 'application.error.unauthorized',
        defaultMessage: 'This page is either missing or your account is not authorized to view its contents.',
        description: '',
      })
      break
    case 'Forbidden':
      message = formatMessage({
        id: 'application.error.forbidden',
        defaultMessage: 'Your account does not have access to this content. If you think it should, ask your account administrator to check your device groups.',
        description: 'Logged in user without access to the requested content',
      })
      break
    case 'User already exists':
      message = formatMessage({
        id: 'invite.userAlreadyExists',
        defaultMessage: 'The user you are attempting to invite already exists in the Altrac system.',
        description: '',
      })
      break
    default:
      message = formatMessage({
        id: 'application.error.notConnected',
        defaultMessage: 'Not connected to Altrac server. Please connect to internet and reload app.',
        description: '',
      })
      break
  }
  return (
    <PopUp
      text={message}
      visible={visible}
      textButton={textButton}
      functionButton={functionButton}
    />
  )
}

PopUpError.propTypes = {
  text: PropTypes.string,
  visible: PropTypes.bool,
  textButton: PropTypes.string,
  functionButton: PropTypes.func,
}

export default injectIntl(PopUpError)
